<template>
  <div>
    <el-card sharow>
      <el-form :model="searchForm" ref="searchForm" size="small" label-width="100px" inline>
        <el-form-item label="分类导航名称" prop="className">
          <el-input v-model.trim="searchForm.className" placeholder="分类导航名称" />
        </el-form-item>
        <el-form-item label=" " label-width="100px">
          <el-button type="primary" @click="search('searchForm')">查询</el-button>
          <el-button @click="reset('searchForm')">重置</el-button>
        </el-form-item>
      </el-form>
      <div>
        <el-button type="primary" @click="add()">添加</el-button>
      </div>
    </el-card>
    <br>
    <el-table border stripe v-loading="loading" :data="tableData" style="width: 100%">
      <el-table-column prop="index" label="序号" minWidth="100" align="center" :formatter="fliteRData">
        <template slot-scope="scope">
          <div>{{ (pageInfo.page - 1) * pageInfo.limit + 1 + scope.$index }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="className" label="分类导航名称" minWidth="250" align="center" :formatter="fliteRData"></el-table-column>
      <el-table-column prop="sortNum" label="排序号" minWidth="160" align="center" :formatter="fliteRData"></el-table-column>
      <el-table-column prop="name" minWidth="160" align="center" label="操作" fixed="right">
        <template slot-scope="scope">
          <a class="blue_Box" @click="action_fn(1,scope.row)">编辑</a>
        </template>
      </el-table-column>
    </el-table>
    <br>
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="pageSizes" layout="total, sizes, prev, pager, next" :total="total" />
    <!-- 添加工作产品 -->
    <addClass ref="addClass" />
  </div>
</template>

<script>
import tableMoudel from "@/libs/mixin/table";

import addClass from "./com/addClass.vue"

import { fenleiApi } from "./api"

export default {
  mixins: [tableMoudel],
  components: { addClass },
  data () {
    return {
      searchForm: {
        className: "",
        state:''
      }
    }
  },
  created () {
    this.getData()
  },
  mounted () {
    this.$bus.$on('update', res => {
      if (res) {
        this.getData()
      }
    })
  },
  methods: {
    async getData () {
      const params = { ...this.pageInfo, ...this.searchForm }
      const res = await fenleiApi.getListPage(params)
      if (res.code !== 0) return
      const { records } = res.data
      this.tableData = records
      this.total = Number(res.data.total)
    },
    action_fn (type, item) {
      switch (type) {
        case 1:
          this.$refs.addClass.init(item)
          break;
      }
    },
    add () {
      this.$refs.addClass.init()
    }
  }
}
</script>

<style>
</style>